import {flow} from "lodash";
import {
	createTeam,
	createTeamFailed,
	createTeamSuccess,
	fetchTeam,
	fetchTeamSuccess,
	hideModalCaptain,
	hideModalInviteCaptain,
	hideModalNewCaptain,
	joinToTeamSuccess,
	leaveFromTeamSuccess,
	removePlayerFailed,
	removePlayerSuccess,
	removeTeamSuccess,
	reviveTeamSuccess,
	showModalCaptain,
	showModalInviteCaptain,
	showModalNewCaptain,
	updateTeamFailed,
	updateTeamSuccess
} from "modules/actions/herd";
import {ApiError} from "modules/utils/Api";
import {EnumHerdStatus} from "modules/utils/enums";
import {createReducer} from "redux-act";

export interface ICreateTeam {
	name: string;
}

export interface IJoinTeam {
	code: string;
}

export interface IChangeCaptain {
	captain_id: number;
}

export interface IRemovePlayer {
	id: number;
}

export interface IPlayer {
	id: number;
	name: string;
	checked_in: number;
}

export interface IHerd {
	id: number;
	name: string;
	status: EnumHerdStatus;
	code: string;
	captain_id: number;
	players: IPlayer[];
}

export interface IHerdsStore {
	team: IHerd | null;
	team_error: ApiError | null;
	is_requested: boolean;
	show_captains_modal: boolean;
	show_new_captain_modal: boolean;
	show_invite_captain_modal: boolean;
}

const initialState: IHerdsStore = {
	team: null,
	team_error: null,
	is_requested: false,
	show_captains_modal: false,
	show_new_captain_modal: false,
	show_invite_captain_modal: false
};

const onRequest = (state: IHerdsStore) => ( {
	...state,
	is_requested: true
} )

const onFetched = (state: IHerdsStore, team: IHerd) => ( {
	...state,
	team,
	is_requested: false
} )

const setError = (state: IHerdsStore, error: Error) => ( {
	...state,
	team_error: error,
	is_requested: false
} )

const cleanError = (state: IHerdsStore, team: IHerd) => ( {
	...state,
	team_error: initialState.team_error,
	is_requested: false,
} )

const cleanTeam = () => ( {
	...initialState
} )
export const herds = createReducer<IHerdsStore>({}, initialState)
	.on(fetchTeam, onRequest)
	.on(createTeam, onRequest)
	.on(fetchTeamSuccess, onFetched)
	.on(joinToTeamSuccess, onFetched)
	.on(createTeamSuccess, flow(onFetched, cleanError))
	.on(updateTeamSuccess, flow(onFetched, cleanError))
	.on(reviveTeamSuccess, flow(onFetched, cleanError))
	.on(removePlayerSuccess, flow(onFetched, cleanError))
	.on(createTeamFailed, setError)
	.on(updateTeamFailed, setError)
	.on(removePlayerFailed, setError)
	.on(removeTeamSuccess, cleanTeam)
	.on(leaveFromTeamSuccess, cleanTeam)

	.on(showModalCaptain, (state) => ( {
		...state,
		show_captains_modal: true
	} ))
	.on(hideModalCaptain, (state) => ( {
		...state,
		show_captains_modal: false
	} ))
	.on(showModalNewCaptain, (state) => ( {
		...state,
		show_new_captain_modal: true
	} ))
	.on(hideModalNewCaptain, (state) => ( {
		...state,
		show_new_captain_modal: false
	} ))
	.on(showModalInviteCaptain, (state) => ( {
		...state,
		show_invite_captain_modal: true
	} ))
	.on(hideModalInviteCaptain, (state) => ( {
		...state,
		show_invite_captain_modal: false
	} ))
;
